var $ = jQuery.noConflict();
var is_mobile = false;
var columnToggle = true;

let cueTriggers = [];
let activeTrigger = false;

let tocTriggers = [];

let violatorTriggers = [];
let activeViolator = false;

let triggerAdjust = 0;

let donateTrigger = 0;

const handleKeypressADA = function() {
  const keycode = (event.keyCode ? event.keyCode : event.which);
  if (keycode == '13') return;
  $(this).trigger('click');
};

const handleKeypressADALink = function() {
  $(this).trigger('click');
};


$(document).ready(function(){

  // if ( $('.donate-btn__container').length && false ) {
  //
  //   donateTrigger = $('.shop_navigation .cartCountContainer').offset().top + $('.shop_navigation .cartCountContainer').height() + 100;
  //   console.log(donateTrigger);
  //
  //   $(window).on('scroll', function(e){
  //     if ( $(window).scrollTop() > donateTrigger ) {
  //       $('body').addClass('donate-scrolled');
  //     } else {
  //       $('body').removeClass('donate-scrolled');
  //     }
  //   });
  // }


  //mobile menu button toggle
  $('.mobile-nav-menu .mobile-nav-icon img').click(function(){
    $('body').toggleClass('hide-overflow');
    $('.open, .close').toggle();
    $('.body-border').toggleClass('mobile-menu-open');
    if($('.mobile-nav-menu').hasClass('active')){
      if($('.mobile-nav-buttons').hasClass('fade')){
        $('.mobile-nav-buttons').removeClass('fade');
        $('.mobile-nav-button').removeClass('active');
        $('.mobile-nav-slide').removeClass('active');
        setTimeout(function(){
          $('.mobile-nav-menu').removeClass('active');
          $('.mobile-nav-menu').toggleClass('hide-overflow');
        },300);
      }else{
        $('.mobile-nav-menu').removeClass('active');
        $('.mobile-nav-menu').toggleClass('hide-overflow');
      }
    }else{
      $('.mobile-nav-menu').addClass('active');
      setTimeout(function(){
        $('.mobile-nav-menu').toggleClass('hide-overflow');
          var button = $('.mobile-nav-button[menu_type="hamburger"]');
        $('.mobile-nav-buttons').addClass('fade');
        $('.mobile-nav-slide').addClass('active');
        $('.mobile-nav-slide-content').hide();
        $('.mobile-nav-button').removeClass('active');
        button.addClass('active');
        $('.mobile-nav-slide-content[menu_type=' + button.attr("menu_type") + ']').show();
      }, 300);
    }
  });


  //mobile menu item select
  $('.mobile-nav-button').click(function(){
    var button = $(this);
    if(button.hasClass('active')){
      $('.mobile-nav-buttons').removeClass('fade');
      $('.mobile-nav-slide').removeClass('active');
      $('.mobile-nav-button').removeClass('active');
      setTimeout(function(){
        $('.mobile-nav-slide').attr('slideopen', '');
      }, 300);
    }else{
      if(button.attr('menu_type') != 'home' && button.attr('menu_type') != 'logger'){
        $('.mobile-nav-slide').attr('slideopen', $(this).attr('menu_type'));
        $('.mobile-nav-buttons').addClass('fade');
        $('.mobile-nav-slide').addClass('active');
        $('.mobile-nav-slide-content').hide();
        $('.mobile-nav-button').removeClass('active');
        button.addClass('active');
        $('.mobile-nav-slide-content[menu_type=' + button.attr("menu_type") + ']').show();
      }
    }


  });

  $('.term-parent .parent-term-link').click(function(event){
    event.preventDefault();
    $(this).parent().toggleClass('active');
    $(this).parent().find('.departments-child-types').slideToggle();
  });


  //menu item select
  $('.nav-buttons .nav-button').click(function(){
    $('body').addClass('hide-overflow');
    var button = $(this);
    if(button.hasClass('active')){
      $('.nav-slide-close').click();
      setTimeout(function(){
        $('.nav-slide-container').attr( 'slideopen', '' );
      }, 550);
    }else{
      if(button.attr('menu_type') != 'home' && button.attr('menu_type') != 'logger' ){
        $('.nav-slide-container').attr( 'slideopen', $(this).attr('menu_type') );
        $('.nav-menu').addClass('fade');
        $('.nav-slide-container').addClass('active');
        $('.nav-slide-bg').addClass('active');
        $('.nav-slide-container .nav-slide-content').hide();
        $('.nav-button').removeClass('active');
        button.addClass('active');
        $('.nav-slide-container .nav-slide-content[menu_type=' + button.attr("menu_type") + ']').show();
      }

    }

  }).on('keypress', handleKeypressADALink);

  //menu close
  $('.nav-slide-close').click(function(){
    $('body').removeClass('hide-overflow');
    $('.nav-button').removeClass('active');
    $('.nav-slide-container').removeClass('active');
    $('.nav-slide-bg').removeClass('active');
    $('.nav-menu').removeClass('fade');
  }).on('keypress', handleKeypressADA);

  if ($(window).width() <= 768) {
    mobile_init();
    is_mobile = true;
   }

  $(window).resize(function(){
    if ( $('.shop_navigation .cartCountContainer').length ) {
      donateTrigger = $('.shop_navigation .cartCountContainer').offset().top + $('.shop_navigation .cartCountContainer').height() + 100;
    }

    if($(window).width() <= 767){
      if(!is_mobile){
        is_mobile = true;
        mobile_init();
      }
    }else{
      // is_mobile = false;
      if($('body').hasClass('hide-overflow') && $('.mobile-nav-menu').hasClass('active')){
        $('.mobile-nav-menu .mobile-nav-icon img.close').click();
      }
    }
    if($('body').hasClass('single-logger') && $(window).width() > 767){
      console.log('change width');
      var imgWidth = $('.logger-featured-img img').width();
      $('.logger-featured-img span').css('width', imgWidth + 'px');
      var containerWidth = imgWidth - $('.article-right').width() * 0.2 + 20;
      $('.logger-featured-img').css('width', containerWidth + 'px');

        $('.adjuster-for-logger-img').remove();
        let upperbound = $('.logger-featured-img').offset().top;
        let lowerbound = upperbound + $('.logger-featured-img').height();
        if ($('.content-container').children().eq(0).is('blockquote')) {
            $('.content-container').children().eq(0).css('margin-top', '0');
        }
        $('blockquote').each(function() {
            if ($(this).offset().top >= upperbound && $(this).offset().top <= lowerbound) {
                let topOfThis = $(this).offset().top;
                console.log("lower bound: " + lowerbound);
                let bottomOfThis = topOfThis + $(this).height();
                console.log("bottom of this: " + bottomOfThis);
                let height = 0;
                if ( bottomOfThis > lowerbound ) {
                    height = lowerbound - topOfThis;
                } else {
                    height = bottomOfThis - topOfThis;
                }

                let spanAdjuster = document.createElement('span');
                $(spanAdjuster).css('height', height + 'px');
                $(spanAdjuster).addClass('adjuster-for-logger-img');

                $(this).addClass('adjust-for-logger-img');
                $(spanAdjuster).prependTo($(this));

                // recheck now that things have moved around
                bottomOfThis = topOfThis + $(this).height();
                if ( bottomOfThis < lowerbound ) {
                    height = $(this).height();
                    $(this).children('.adjuster-for-logger-img').each(function() {
                        $(this).css('height', height + 'px');
                    });
                }

            }
        });
    } else if ($('body').hasClass('single-logger')) {
        $('.adjuster-for-logger-img').remove();
        $('blockquote').removeClass('adjust-for-logger-img');
    }

      if ( $('.topBannerAd:visible').length ) {
            $('.shop_navigation').addClass('ad-knocked');
    } else {
        $('.shop_navigation').removeClass('ad-knocked');
    }
  });

    var maxColumnistHeight = 280;

    $('.columnist .info-container').each(function() {
        if ($(this).height() > maxColumnistHeight) {
            maxColumnistHeight = $(this).height();
        }
    });

    $('.columnist .info-container').each(function() {
        if (window.innerWidth > 767 ) {
            $(this).css('height', maxColumnistHeight + 'px');
        } else {
            $(this).css('height', 'auto');
        }
    });

    window.addEventListener('resize', function() {
        $('.columnist .info-container').css('height', 'auto');
        $('.columnist .info-container').each(function() {
            if ($(this).height() > maxColumnistHeight) {
                maxColumnistHeight = $(this).height();
            }
        });

        $('.columnist .info-container').each(function() {
            if (window.innerWidth > 767 ) {
                $(this).css('height', maxColumnistHeight + 'px');
            } else {
                $(this).css('height', 'auto');
            }
        });
    });


    if ($('body').hasClass('term-columns')) {

        // columns interactions
    $('.column-spacer').hide();
    $('.latest-columns li').hide();
    $('.latest-columns li.front-facing').show();

    $('.columnist').click(function() {
        if (window.innerWidth > 767 ) {
            if (!$(event.target).hasClass('more-link')) {
                event.preventDefault();
        var author = $(this).attr('author');
        if (columnToggle) {
            $('.columnist').hide();
            $(this).show();
            $('.column-spacer').show();
            $('.info-container h5').hide();
            $('.info-container h4').hide();
            $('.info-container h6').hide();
            $('.columnist .info-container').each(function() {
                $(this).css('height', 'auto');
            });
            $(this).addClass('active');
            $('.latest-columns li').hide();
            $('.latest-columns li').css('animation-name', 'latest-toggle');
            $('.latest-columns li').each(function() {
                if ($(this).attr('author') == author) {
                    $(this).show();
                }
            });
            columnToggle = false;
        } else {
            $(this).removeClass('active');
            $('.latest-columns li').css('animation-name', 'latest');
            $('.latest-columns li').hide();
            $('.latest-columns li.front-facing').show();
            $('.info-container h5').show();
            $('.info-container h4').show();
            $('.info-container h6').show();
            $('.columnist .info-container').each(function() {
                if (window.innerWidth > 767 ) {
                    $(this).css('height', maxColumnistHeight + 'px');
                } else {
                    $(this).css('height', 'auto');
                }
            });
            setTimeout(function() {
                $('.column-spacer').hide();
                $('.columnist').show();
                columnToggle = true;
            }, 400);
        }
        }
        }
    });
    }





    //single logger post image placement
            console.log("this is hitting the logger load");

	            console.log("FIRING");
        if ($(window).width() > 767) {
        $('.logger-featured-img img').on('load', function() {
            var imgWidth = $('.logger-featured-img img').width();
            console.log("IMAGE WIDTH: " + imgWidth);
            var containerWidth = imgWidth - $('.article-right').width() * 0.2 + 20;
            console.log("CONTAINER WIDTH: " + containerWidth);
            $('.logger-featured-img').css('width', containerWidth + 'px');
            $('.logger-featured-img span').css('width', imgWidth + 'px');

            let upperbound = $('.logger-featured-img').offset().top;
            let lowerbound = upperbound + $('.logger-featured-img').height();
            if ($('.content-container').children().eq(0).is('blockquote')) {
                $('.content-container').children().eq(0).css('margin-top', '0');
            }
            $('blockquote').each(function() {
                if ($(this).offset().top >= upperbound && $(this).offset().top <= lowerbound) {
                    let topOfThis = $(this).offset().top;
                    console.log("lower bound: " + lowerbound);
                    let bottomOfThis = topOfThis + $(this).height();
                    console.log("bottom of this: " + bottomOfThis);
                    let height = 0;
                    if ( bottomOfThis > lowerbound ) {
                        height = lowerbound - topOfThis;
                    } else {
                        height = bottomOfThis - topOfThis;
                    }

                    let spanAdjuster = document.createElement('span');
                    $(spanAdjuster).css('height', height + 'px');
                    $(spanAdjuster).addClass('adjuster-for-logger-img');

                    $(this).addClass('adjust-for-logger-img');
                    $(spanAdjuster).prependTo($(this));

                    // recheck now that things have moved around
                    bottomOfThis = topOfThis + $(this).height();
                    if ( bottomOfThis < lowerbound ) {
                        height = $(this).height();
                        $(this).children('.adjuster-for-logger-img').each(function() {
                            $(this).css('height', height + 'px');
                        });
                    }

                }
            });
        }).each(function() {
            if ( this.complete )
                $(this).trigger('load');
        });
        }



    //single contributor grid to list view
    if($('body').hasClass('single-contributor')){
      $('.contributor-view .more-link').click(function(){
        var selected = $(this);
        $('.contributor-view .more-link').removeClass('active');
        selected.addClass('active');

        if(selected.attr('type') == 'grid'){
          $('.contributor-list-view').fadeOut(400, function(){
              $('.contributor-grid-view').fadeIn();
          });

        }
        if(selected.attr('type') == 'list'){
          $('.contributor-grid-view').fadeOut(400, function(){
            $('.contributor-list-view').fadeIn();
          });

        }
      });
    }

    //SNAPS FUNCTION
    var initialClick = false;
    $('.snaps').click(function(){
      var snaps = parseInt($('.snaps a span').html().split(",").join(""));
      $('.snaps a span').html(numberWithCommas(++snaps));
      var $this = $(this);
      var randomLeft = Math.floor(Math.random() * 90);

      $this.append('<div class="plusOne floatUp" style="left: ' + randomLeft +'%">+1</div>');


      var postID = $this.attr('postID');
      var clickNum = $(this).data('clickNum');

      //check if first click, wait a second to update
      if(!clickNum || clickNum == 0){
        clickNum = 1;
        $this.data('clickNum', clickNum);
        setTimeout(function(){
          snapClicks($this.data('clickNum'), postID);
          $this.data('clickNum', 0);
        },1000);
      }else{
        //if not first click, increment number of clicks
        $this.data('clickNum', ++clickNum);
      }

    });


    if($('.snaps').length > 0){
      // GET Snaps
      var postID = $('.snaps').attr('postID');

      $.ajax({
    	    url: ajaxurl,
    	    data: {
    	        action: 'do_ajax',
    	        fn: 'getSnaps',
              postID: postID,
    	    },
    	    success: function(data){
            if(data !== null){
              if(data.length == 0){
                $('.snaps span').html('0');
              }else{
                $('.snaps span').html(numberWithCommas(data));
              }
            }
    	    },
    	    complete:function(){
      		},
      		error: function(errorThrown) {
      			console.log(errorThrown);
      		}
    	});
    }

    // AJAX for more posts
    if($('body').hasClass('archive')){
      $('.more-posts').attr('href', '');
      var paged = 1;
      var ajaxRun = false;

      $('.more-posts').click(function(e){
        e.preventDefault();
        console.log('paged: ' + paged);
        var $this = $(this);
        var listed = false;
        if($this.parent().hasClass('list-posts')){
          listed = true;
        }

        console.log(listed);

        ajaxRun = true;
        $this.addClass('loading');

        $.ajax({
             url: ajaxurl,
             data: {
                 action: 'do_ajax',
                 fn: 'more_cool_stuff',
                 art_type: $this.parent().attr('article_type'),
                 paged: paged,
                 listed: listed,
                 per_page: $this.parent().attr('posts_per_page'),
                 offset: $this.attr('offset'),
             },
             success: function(data){
               if(data !== null && data.length > 0){
                 console.log(data);
                 // results = true;
                 // data.insertBefore($('.post-feed-container .more-posts'));
                 $this.removeClass('loading');
                 if(listed){
                   // $('.post-feed-container .more-posts').before(data);
                   $this.parent().find('.more-posts').before(data);
                 }else{
                   // $('.post-feed-container .post-feed').append(data);
                   $this.parent().find('.post-feed').append(data);
                 }
                 ajaxRun = false;
                   paged++;
               }else{
                    $this.removeClass('loading');
                    $this.addClass('all-posts-loaded');
                    $this.text('No more posts to show');
                   $this.append('<div class="star"></div>')
               }
             },
             complete:function(){
           },
           error: function(errorThrown) {
             console.log(errorThrown);
           }
         });







      });
    }



    //DYNAMIC SEARCH
    var searchTimeout = null;
    var results = false;
    $('.site-header input[type="text"]').on('input propertychange paste', function() {
      var query = this.value;
      $('.search-load').addClass('active');
      $('.search-resultss').addClass('loading');
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(function(){
        if(query == ''){
          $('.search-results-cont').html('');
          $('.search-load').removeClass('active');
          $('.search-resultss').removeClass('loading');
        }
        console.log('queryyy: ' + query);

         var searchurl = searchURL + encodeURIComponent(query);
         $.getJSON(searchurl, function (data) {
           // console.log(data);
           if(data != null){
             results = true;
             $('.search-load').removeClass('active');
             $('.search-resultss').removeClass('loading');
             $('.search-results-cont').addClass('results-shown');
             $('.search-results-cont').html('');
             $.each(data, function(index, value){


               var h3 = '<h3>' + value.title + '</h3>';
               var date = '<h6 class="clarendon">' + value.date + '</h6>';
               var h6 = '';
               if(value.post_type == 'contributor'){
                 h6 = '<h6>Contributor</h6>';
                 date = '';
               }
               if(value.post_type == 'post'){
                 if(value.contributor != null){
                    h6 = '<h6>' + value.contributor.post_title + '</h6>';
                 }
               }

               if(value.post_type == 'logger'){
                 h6 = '<h6>Logger</h6>';
               }

               var article = '<article class="sidebar-search-article">' + date + h3 + h6 + '</article>';

               var element = '<a href="' + value.url + '" class="searched-article">' + article +'</a>';
               $('.search-results-cont').append(element);

             });
             var searchPage = '<div><a href="' + homeurl + '?s=' + encodeURIComponent(query)
 +'" class="more-link">More</a></div>';
             $('.search-results-cont').append(searchPage);
           }else{
             results = false;
           }

          });

      }, 300);
    });


    $('[menu_type="search"]').keydown(function(event){
      var $this = $(this);
      if(results){
        if(event.keyCode == 40){
          // $('.site-header input[type="text"]').blur();
          // $('[menu_type="search"]').focus();

          if(!$('.results-shown a').hasClass('selected')){
            $('.results-shown .searched-article:nth-child(1)').addClass('selected');
          }else{
            var initSelected = $('.results-shown a.selected');
            if(initSelected.next().length != 0 && initSelected.next().hasClass('searched-article')){
              initSelected.removeClass('selected');
              initSelected.next().addClass('selected');
            }

          }
          return false;
        }
        if(event.keyCode == 38){

          var initSelected = $('.results-shown a.selected');

          initSelected.removeClass('selected');
          initSelected.prev().addClass('selected');

          return false;
        }

        if(event.keyCode == 13){


          if($('.results-shown a').hasClass('selected')){
            event.preventDefault();
            window.location.href = $('.results-shown a.selected').attr('href');
          }

        }

      }
    });


    $('.site-header input[type="submit"]').click(function(event){
      event.preventDefault();
      var $this = $(this);
      var query = $(this).prev().val();
      window.location.href = homeurl + '?s=' + encodeURIComponent(query);
    });

    // WINDOW SCROLL FUNCTIONS
    $(window).scroll(function(){
      var scrollTop = $(window).scrollTop();
      //console.log('position', scrollTop);
      //PROGRESS BAR
      if($('.article-left').length !== 0){
        var parentScroll = $('.content-container');
        var childScroll = $('.article-sticky-container');


        var midpoint = $(window).height() / 2 - ($(window).height() - $('.article-left').offset().top);
        if(scrollTop > midpoint){
          //console.log('start progression');

          var progression = Math.round(((scrollTop - midpoint) / (parentScroll.height())) * 100);

         // console.log('progression', progression);
          if(progression > 100){
            $('#dark_circle').attr('class', 'per-100');
          }else{
            $('#dark_circle').attr('class', 'per-' + progression);
          }
        }else{
            $('#dark_circle').attr('class', 'per-0');
        }
      }

      if($('body').hasClass('home')){
        $('.layer-up').css('transform', 'translateY(' + scrollTop*1.1 +'px)');
        $('.layer-down').css('transform', 'translateY(' + (-scrollTop/7) +'px)');
        $('.layer-static').css('top', scrollTop);
        $('.header-logo').css('top', (scrollTop + 50) + 'px');
      }

        if($('.subscriber-popup-container').hasClass('hidden')) {
            if (scrollTop > $('header').height()) {
                $('.subscriber-popup-container').removeClass('hidden');
                document.cookie = "subscriber-popup=visited;path=/;max-age=31536000";
            }
        }


        /*var adKnockGate = true;

        // Ad knocks down toolbar
        if ( $('.topBannerAd:visible').length ) {
            if ( scrollTop < 112 ) {
                $('.ad-knocked .nav-buttons').css('top', 112 - scrollTop +'px');
                if ( !adKnockGate ) {
                    adKnockGate = true;
                }
            } else {
                if ( adKnockGate ) {
                    $('.ad-knocked .nav-buttons').css('top', 0);
                    adKnockGate = false;
                }
            }
        } else {
            $('.ad-knocked .nav-buttons').css('top', 0);
        }*/

    });




    //comic/schema post
    if($('article').hasClass('single-type-comic')){
      $('.comic-gallery-container').slick({
        dots: false,
        swipeToSlide: false,
        infinite: false,
        prevArrow: $('.gallery-prev'),
        nextArrow: $('.gallery-next'),
        touchMove: false,
      });
      $('.enhanced-image').slick({
        dots: false,
        swipeToSlide: false,
        swipe: false,
        infinite: false,
        touchMove: false,
        prevArrow: $('.enhanced-arrow-prev'),
        nextArrow: $('.enhanced-arrow-next'),

      });
      $('.comic-gallery-container').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $('.comic-gallery-page span').html(nextSlide + 1);
        $('.enhanced-image').slick('slickGoTo',nextSlide);

      });
      $('.enhanced-image').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $('.comic-gallery-page span').html(nextSlide + 1);
        $('.comic-gallery-container').slick('slickGoTo',nextSlide);

            $('.comic-img-enhance').animate({
              scrollLeft: 0,
              scrollTop: 0,
            }, 200);
      });


      $('.enhance-button').click(function(){
        // var largeImg = $('.slick-current').attr('large');
        // $('.enhanced-image').html('<img src="' + largeImg +'" />');
        $('')
        $('body').addClass('hide-overflow');
        $('.comic-img-enhance').fadeIn();
        $('.enhanced-image').get(0).slick.setPosition();

      });

      $('.enhanced-close span').click(function(){
        $('body').removeClass('hide-overflow');
        $('.comic-img-enhance').fadeOut();
      });


      $(document).keyup(function(e) {
        if (e.keyCode == 27 && $('.comic-img-enhance').css('display') == 'block') {
            $('body').removeClass('hide-overflow');
            $('.comic-img-enhance').fadeOut();
        }
      });


    }

    //subscriber popup
    $('.subscriber-dismiss').click(function() {
        $('.subscriber-popup-container').addClass('disabled');
    });

    $('.subscriber-popup-container.hidden').each(function() {
        setTimeout(function() {
	        console.log(document.cookie);
            $('.subscriber-popup-container').removeClass('hidden');
            document.cookie = "subscriber-popup=visited;path=/;max-age=31536000";
        }, 5000);
    });

    var $form = $('.subscriber-content form');

    if ( $form.length ) {
        $('.subscriber-content button').bind('click', function ( event ) {
            if ( event ) event.preventDefault();
            // validate_input() is a validation function I wrote, you'll have to substitute this with your own.
            if ( validate_input($form) ) {
                register($form);
            }
        });
    }

    // violator
    $('.violator-close').click(function() {
        $('.top-violator').addClass('dismissed');
        $('#page').addClass('dismissed');
        document.cookie = "violator=dismissed;path=/;max-age=2592000";
    });

    // limited time offer violator
    $('.offer-close').click(function() {
        $('.limited-time-violator').addClass('dismissed');
        document.cookie = "limitedtimeoffer=dismissed;path=/";
    });
    /*if(!$('.limited-time-violator').hasClass('dismissed')){
	    setTimeout(function(){
		    $('.offer-close').click();
	    },7000);

    }*/



//DFP Scripts

  var slots = {};
  googletag.cmd.push(function() {
      if(($(".single-type-article").length > 0 || $(".single-type-logger").length > 0 || $(".single-type-interview").length > 0 || $(".single-type-featured").length > 0) && $(".single-poetry").length == 0){
        buildInlineAds();
        console.log("building Inline Ads");
      }


    $('.dfp_block').each(function(){
      var adData = $(this).data();
       var adSize = adData.size.split('x');
      if($(window).width() < 900){
	      adSize = adData.mobilesize.split('x');
      }


      var adCats = adData.cats;
      console.log(adData);
      var adLabel = adData.label;
      slots[adLabel] = googletag.defineSlot('/21709106903/'+adData.label, [[parseInt(adSize[0]),parseInt(adSize[1])]], adLabel).addService(googletag.pubads());
/*
      if(dfp_targeting.page) {
        slots[adLabel].setTargeting('pages', dfp_targeting.page);
      }
*/


/*
      if(!adCats && dfp_targeting){ // No categories were specifically provided
        if(dfp_targeting.cats){
          slots[adLabel].setTargeting('site-categories', dfp_targeting.cats);
        }
        if(dfp_targeting.browse){
          slots[adLabel].setTargeting('browse-tags', dfp_targeting.browse);
        }
      }
      else if(adCats){
        slots[adLabel].setTargeting('site-categories', adCats);
      }
*/



    });

    googletag.pubads().enableSingleRequest();
    googletag.pubads().collapseEmptyDivs(true);
    googletag.enableServices();
  });
  check_for_ads_in_view();



//Filter ISsue by year

$(".yearLink").each(function(){
	$(this).click(function(i,x){
		var year = $(this).attr('attr-year');
		loadByYear(year)
	})

});

    if ( $('.topBannerAd:visible').length ) {
            $('.shop_navigation').addClass('ad-knocked');
    }

    if ($(window).width() <= 767) {
        $('.woocommerce-MyAccount-navigation').click(function() {
            $('.woocommerce-MyAccount-navigation ul').toggleClass('active');
        });
    }


    var $form_2 = $('#mc_embed_signup_2 form');

    if ( $form_2.length ) {
        $('#mc-embedded-subscribe-2').bind('click', function ( event ) {
            if ( event ) event.preventDefault();
            // validate_input() is a validation function I wrote, you'll have to substitute this with your own.
            if ( validate_input($form_2) ) {
                register($form_2);
            }
        });
    }


    $('.shareHyperlink').click(function() {
        event.preventDefault();
        $('.permalink-holder').get(0).select();
        document.execCommand('copy');
        $(this).addClass('copied');
        setTimeout(function() {
            $('.shareHyperlink').removeClass('copied');
        }, 1200);
    });


    $('.galleryButtonWrapper').each(function() {
        let cur = $(this).get(0);
        if (cur.scrollWidth > cur.offsetWidth) {
            $(this).parent().addClass('scrollable');
        }
    });

    $('.galleryButtonWrapper').scroll(function(){
        let scrolled = $(this).get(0).scrollLeft;
        if (scrolled != 0) {
            $(this).parent().removeClass('scrollable');
        } else {
            $(this).parent().addClass('scrollable');
        }
    });

    if ( $('.top-violator-background') ) {
        let topViolatorCookie = getCookie('violator');
        if (topViolatorCookie != "") {
            $('.top-violator-background').remove();
        }
    }

    if ( $('.limited-time-violator') ) {
        let offerCookie = getCookie('limitedtimeoffer');
        if (offerCookie != "") {
            $('.limited-time-violator').remove();
        }
    }

    if ( $('.subscriber-popup-container') ) {
        let offerCookie = getCookie('subscriber-popup');
        if (offerCookie != "") {
            $('.subscriber-popup-container').remove();
        }
    }

    // ensure that all more links have an offset
    $('.more-link[offset="0"]').each(function() {
        var loadedArticles;
        if ($(this).siblings('.post-feed').length > 0) {
            loadedArticles = $(this).prev('.post-feed').children().length;
        } else {
            loadedArticles = $(this).siblings('article').length;
        }
        $(this).attr('offset', loadedArticles);
    });

    $('.single-post-cat').click(function (e) {
        e.preventDefault();
        let target = $(this).attr('href');
        if (target != "") {
            window.location.href = target;
        }
    });

        var toSlick =  $('.gallery.inpage .galleryHolder');
        toSlick.each(function(index) {
            var id = $(this).parent().attr('id') + index;
            $(this).parent().attr('id', id);

            $(this).slick({
                slidesToShow: 1,
                cssEase: 'ease-in-out',
                easing:'easeInOutQuint',
                arrows: false,
                adaptiveHeight: true
            });


            $(this).on('beforeChange', function(event, slick, currentSlide, nextSlide){
                console.log("changing");
                $("#"+id+" .gallery-button").removeClass('active');
                $('#'+id+' .gallery-button').eq(nextSlide).addClass('active');
                $('#'+id+' .gallery-slide-idicator').css('left', $('#'+id+' .gallery-button').eq(nextSlide).get(0).offsetLeft);
            });

            $('#'+id+' .gallery-button').each(function (i, val) {
                var slideNum = jQuery(val).attr('imageIndex');
                var currentButton = jQuery(this);
                if(i == 0){
                     currentButton.addClass('active');
                     jQuery('.gallery-slide-idicator').css('left', currentButton.position().left);
                }
                currentButton.click(function () {
                    $("#"+id+" .galleryHolder").slick('slickGoTo', slideNum);
                    $("#"+id+" .gallery-button").removeClass('active');
                    $(this).addClass("active");
                    $('#'+id+' .gallery-slide-idicator').css('left', currentButton.get(0).offsetLeft);
                });
            });
        });

    var navIssueImages = $('.nav-issues img'),
        navIssueImagesLoaded = 0;

    navIssueImages.load(function(){
        navIssueImagesLoaded++;
        console.log("Issue images loaded: " + navIssueImagesLoaded);

        if (navIssueImagesLoaded == navIssueImages.length) {
            $('.nav-issues').each(function() {
                let cur = this;
                console.log("SCROLL WIDTH: " + cur.scrollWidth);
                if (cur.scrollWidth > cur.offsetWidth) {
                    $(this).addClass('scrollable');
                    $(this).parent().addClass('scrollable-right');
                }
            });
        }
    }).each(function() {
        if (this.complete) {
            $(this).trigger('load');
        }
    });;

    $('.nav-issues.scrollable').scroll(function(){
        let scrolled = $(this).get(0).scrollLeft;
        let end = this.scrollWidth - this.offsetWidth;
        if (scrolled >= 24) {
            $(this).parent().addClass('scrollable-left');
        } else {
            $(this).parent().removeClass('scrollable-left');
        }

        if (scrolled <= end - 24) {
            $(this).parent().addClass('scrollable-right');
        } else {
            $(this).parent().removeClass('scrollable-right');
        }
    });

    /*
     * TRYING TO FIX LINE SHITS
     */
    var ellipsismargin = 16;
    if ($('.product-single_issueContent .ellipsis') && false ) {
        $('.product-single_issueContent .ellipsis').each(function(){
            let leftItem = $(this).prev().children();
            let rightItem = $(this).next().children();

            let startX = Math.floor(extendEllipsis(leftItem, 'L')) + ellipsismargin;
            let endX = Math.floor(extendEllipsis(rightItem, 'R')) - ellipsismargin;

            let width = endX - startX;

            let target = $(this).parent();
            $(this).css('opacity', 0);

            let newEllipsis = document.createElement('div');
            $(newEllipsis).addClass('ellipsis');
            $(newEllipsis).html('<div></div');
            $(newEllipsis).css({
                "position": "absolute",
                "left": startX  + "px",
                "width": width + "px",
                "padding": 0,
            });

            $(newEllipsis).appendTo(target);


            console.log("START: " + startX + "\nEND:" + endX);
        });
    }

    $('.recurring-total small').each(function() {
        let thetext = $(this).text();
        thetext = thetext.replace('First renewal: ', '');
        $(this).text(thetext);
    });

    // smooth scrollers
    if ( $('.smooth-scroller').length ) {
      $('.smooth-scroller').click(function(e){
        e.preventDefault();
        console.log("CLICK");
        const target = $(this).attr('href');
        $('html, body').animate({
            scrollTop: $(target).offset().top - 24
         }, 500);
      }).keypress(function(){
        $(this).trigger('click');
      });
    }

    if ( $('.is-style-cmyk-typing-class, .is-style-cmyk-typing-class-lines').length ) {
      const controller = new ScrollMagic.Controller({

      });

      // const typingGroups = [[]];
      //
      // $('.is-style-cmyk-typing-class, .is-style-cmyk-typing-class-lines').each(function( index ){
      //   typingGroups[ typingGroups.length - 1 ].push( $(this).get(0) );
      //   if ( !($(this).next().hasClass('is-style-cmyk-typing-class') || $(this).next().hasClass('is-style-cmyk-typing-class-lines')) ) {
      //     typingGroups.push([]);
      //   }
      // });
      //
      // for (var i = 0; i < typingGroups.length; i++) {
      //   const cur = typingGroups[i];
      //   console.log( $(cur) );
      //   $(cur).wrapAll( "<span class='typed-container' id='typed-"+ i +"' />");
      //   const parent = $('#typed-' + i);
      //   parent.css('display', 'block');
      //   const height = parent.height();
      //   parent.css('display', 'inline');
      //   $(cur).remove();
      //   if ( cur.length > 0 ) {
      //     let fullHTML = '';
      //     for (var j = 0; j < typingGroups[i].length; j++) {
      //       const curEl = typingGroups[i][j];
      //       fullHTML += curEl.outerHTML;
      //     }
      //
      //     const options = {
      //       strings: [fullHTML],
      //       loop: false
      //     };
      //
      //
      //
      //     const typed = new Typed('#typed-' + i, options);
      //
      //     console.log(typed);
      //
      //     const textScene = new ScrollMagic.Scene({
      //       triggerElement: cur[0],
      //       triggerHook: 0.9,
      //       duration: '200%'
      //     }).on('enter', function(){
      //       // console.log("HELLOOOOOO");
      //       // typed.start();
      //     }).addTo(controller);
      //   }
      // }

      $('.wp-block-cmyk-card').each(function(index){
        let queue = [];

        let typer = setInterval(function(){
          if ( queue.length > 0 ) {
            $(queue.shift()).addClass('active');
          }
        }, Math.max(20 - (index * 2), 0));

        $(this).find('.is-style-cmyk-typing-class, .is-style-cmyk-typing-class-lines').each(function(){
          let args = {
            type: 'chars',
            charsClass: 'is-style-cmyk-typing-class__inner'
          };

          if ( $(this).hasClass('is-style-cmyk-typing-class-lines') ) {
            args = {
              type: 'lines',
              linesClass: 'is-style-cmyk-typing-class__inner'
            };
          };

          new SplitText($(this).get(0), args);

          // $(this).find('.is-style-cmyk-typing-class__inner').each(function(index){
          //   $(this).css('transition-delay', (index*3) + 'ms');
          // });

          const thisRef = $(this);

          const textScene = new ScrollMagic.Scene({
            triggerElement: $(this).get(0),
            triggerHook: 0.9,
            duration: '200%'
          }).on('enter', function(){
            const needsBuffer = thisRef.hasClass('is-style-cmyk-typing-class-lines');
            thisRef.find('.is-style-cmyk-typing-class__inner').each(function(){
              if ( needsBuffer ) {
                const dummyEl = document.createElement('span');
                for (var i = 0; i < 15; i++) {
                  queue.push( dummyEl );
                }
              }
              queue.push(this);
            });
          }).addTo(controller);
        });
      });


    }

    if ( $('.bm-transcript__header__button').length ) {
      $('.bm-transcript__header__button').on('click', function(){
        $(this).toggleClass('active');
        $(this).parent().next().slideToggle();
      }).on('keypress', handleKeypressADA);
    }

}); /* DOCUMENT READY END */

$(window).load(function(){
  if ( !$('body').hasClass('post-template-template-hub') ) {
    triggerAdjust = $(window).height();
    $(window).resize(function(){
      triggerAdjust = $(window).height();
    });
  } else {
    triggerAdjust = $(window).height() / 2;
    $(window).resize(function(){
      triggerAdjust = $(window).height() /2;
    });
  }

  console.log(triggerAdjust);

  if ( $('.storytelling-cue').length ) {
    console.log("Helllooooooooooo");
    $('.storytelling-cue').each(function(index){
      cueTriggers.push({
        el: $(this),
        blockHeight: $(this).offset().top,
        triggers: $(this).data('cues')
      });

      $('.storytelling-background').append(`<div class="storytelling-background__container bg-`+ index +`"></div>`);
      $('.storytelling-foreground').append(`<div class="storytelling-foreground__container fg-`+ index +`"></div>`);

      if ( $(this).children().length ) {
        $(this).children().each(function(){
          if ( $(this).hasClass('foreground') ) {
            $(this).appendTo($('.fg-' + index));
          } else {
            $(this).appendTo($('.bg-' + index ))
          }
        });
      }
    });

    updateTriggers();

    $(window).on('scroll', updateTriggers);
    $(window).on('resize', function(){
      cueTriggers = [];
      $('.storytelling-cue').each(function(index){
        cueTriggers.push({
          el: $(this),
          blockHeight: $(this).offset().top,
          triggers: $(this).data('cues')
        });
      });
    });

    console.log(cueTriggers);
  }

  if ( $('.wp-block-cmyk-toc-cue').length ) {
    $('.wp-block-cmyk-toc-cue').each(function(index){
      tocTriggers.push({
        el: $(this),
        blockHeight: $(this).offset().top,
        triggers: '#' + $(this).attr('id'),
        subsection: $(this).data('subsection')
      });
    });

    console.log( tocTriggers );

    $(window).on('scroll', function() {
      const scrollTop = $(document).scrollTop() + 40;
      for (let i = tocTriggers.length - 1; i >= 0; i--) {
        if ( scrollTop >= tocTriggers[i].blockHeight ) {
          // console.log(i);
          $('.wp-block-cmyk-toc__item a').not('[href="' + tocTriggers[i].triggers + '"]').removeClass('active');
          $('.wp-block-cmyk-toc__item a').removeClass('active-secondary');
          $('.wp-block-cmyk-toc__item a[href="' + tocTriggers[i].triggers + '"]').addClass('active');
          // console.log(tocTriggers[i].subsection);
          if ( tocTriggers[i].subsection == true ) {
            for ( ; i >= 0; i-- ) {
              if ( tocTriggers[i].subsection == false ) {
                $('.wp-block-cmyk-toc__item a[href="' + tocTriggers[i].triggers + '"]').addClass('active-secondary');
                break;
              }
            }
          }
          break;
        }
      }
    });

    $(window).on('resize', function(){
      tocTriggers = [];
      $('.wp-block-cmyk-toc-cue').each(function(index){
        tocTriggers.push({
          el: $(this),
          blockHeight: $(this).offset().top,
          triggers: '#' + $(this).attr('id')
        });
      });
    });
  }

  if ( $('.storytelling-violator__cue').length ) {
    $('.storytelling-violator__cue').each(function(){
      violatorTriggers.push({
        el: $(this),
        blockHeight: $(this).offset().top,
        innerHTML: $(this).html()
      });
    });

    $(window).on('scroll', function(){
      const scrollTop = $(document).scrollTop() + triggerAdjust;
      console.log(scrollTop);
      let isActive = false;
      for (let i = violatorTriggers.length - 1; i >= 0; i--) {
        if ( scrollTop >= violatorTriggers[i].blockHeight && !(scrollTop <= triggerAdjust) ) {
          if ( $(document).scrollTop() >= ( $(document).height() - $(window).height() - $('footer#colophon').height() + 80) ) {
            $('.storytelling-violator').removeClass('active');
            break;
          } else if ( activeViolator !== i ) {
            if ( $('.storytelling-violator').html() != violatorTriggers[i].innerHTML) {
              $('.storytelling-violator').html( violatorTriggers[i].innerHTML );
            }

            if ( ! $('.storytelling-violator').hasClass('active') ) {
              $('.storytelling-violator').addClass('active');
            }

            activeViolator = i;
          } else {
            if ( ! $('.storytelling-violator').hasClass('active') ) {
              $('.storytelling-violator').addClass('active');
            }
          }

          isActive = true;
          break;
        }
      }

      if ( !isActive ) {
        $('.storytelling-violator').removeClass('active');
        activeViolator = false;
      }
    })

    $(window).on('resize', function(){
      violatorTriggers = [];
      $('.storytelling-violator__cue').each(function(){
        violatorTriggers.push({
          el: $(this),
          blockHeight: $(this).offset().top,
          innerHTML: $(this).html()
        });
      });
    });
  }

  if ( $('.wp-block-cmyk-parallax').length ) {
    $('.wp-block-cmyk-parallax').each(function(){
      const count = $(this).children().length;
      $(this).children().each(function(index){
        if ( $(this).find('img').length ) {
          new simpleParallax( $(this).find('img').get(0), {
            scale: 1 + (( index / count ) * 1),
            orientation: $(this).data('orientation')
          });
        }
      });
    });
  }

  if ( $('.storytelling-header__image > img').length ) {
    new simpleParallax($('.storytelling-header__image > img').get(0), {
      scale: 1.2
    });
  }

  if ( $('.wp-block-cmyk-chapter__image').length ) {
    $('.wp-block-cmyk-chapter__image').each(function(){
      if ( $(this).find('img').length ) {
        new simpleParallax( $(this).find('img').get(0), {
          overflow: true,
          orientation: $(this).data('orientation')
        });
      }
    });

  }
});

function updateTriggers() {
  let inTrigger = false;
  const scrollTop = $(document).scrollTop() + triggerAdjust;
  for ( let i = cueTriggers.length - 1; i >= 0; i-- ) {
    if ( cueTriggers[i].blockHeight <= scrollTop && !(scrollTop <= triggerAdjust) ) {
      console.log(i);
      $('body').addClass('cue-' + i);
      inTrigger = true;
      if ( $('body').hasClass('cue-' + (i + 1)) ) {
        $('.bg-' + i ).removeClass('active');
        if ( $('.bg-' + i).find('video').length ) {
          $('.bg-' + i).find('video').get(0).pause();
        }
      } else {
        $('.bg-' + i ).addClass('active');
        $('.fg-' + i ).addClass('active');
        if ( $('.bg-' + i).find('video').length ) {
          $('.bg-' + i).find('video').get(0).play();
        }
      }
    } else {
      $('body').removeClass('cue-' + i);
      $('.bg-' + i ).removeClass('active');
    }
  }
  if ( !inTrigger ) {
    $('body').removeClass('cue-0' );
  }
}

function extendEllipsis( $item, direction ) {
    let content = $item.text();
    $item.html(' ');
    for (var i = 0; i < content.length; i++) {
        let posWrapper = document.createElement('span');

        /*let rVal = Math.floor(Math.random() * 255);
        let gVal = Math.floor(Math.random() * 255);
        let bVal = Math.floor(Math.random() * 255);
        posWrapper.style.color = "rgb("+ rVal +", "+ gVal +", "+ bVal +")";*/

        posWrapper.textContent = content[i];


        $item.get(0).appendChild(posWrapper);
    }

    let posX = 0;

    let beginningOfContainer = $item.parent().parent().offset().left;
    //console.log("beginning: " + beginningOfContainer);

    if ( direction === 'L' ) {
        if ( $item.children().length > 1 ) {
            let cur = $item.children().eq(0);
            let curLevel = cur.offset().top;

            while ( cur.next().length > 0 ) {
                if ( cur.next().offset().top != curLevel) {
                    cur.prev().css('background', 'red');
                    return cur.prev().offset().left + cur.width() - beginningOfContainer;
                }
                cur = cur.next();
            }

            cur.css('background', 'red');

            posX = cur.offset().left + cur.width() - beginningOfContainer;
        }
    } else {
        if ( $item.children().length > 0 ) {
            posX = $item.children().eq(0).offset().left - beginningOfContainer;
            $item.children().eq(0).css('background', 'red');
        }
    }

    return posX;

}







//DFP Ads
function buildInlineAds(){
  //Create incontent
var adSizes = ["inline_article_1","inline_article_2","inline_article_3","inline_article_4","inline_article_5","inline_article_6","inline_article_7","inline_article_8","inline_article_9"];

if($(".content-container").length != 0){
  var tags = $(".content-container").children().not('.wp-block-image');
  //make start after 5th p tag.. if mobile, start immediately.
  var adCount = 2;
  if(is_mobile === true){
    var adCount = 0;
  }
  var currentAdCount = 0;
  var maxChildCount = 7;
  var maxMobileChildCount = 4;
  var maxMobileAds = 8;
  var maxDesktopAds = 8;
  //check if the article is long.. if so spread the ads farther out.. based on the count.
  if(tags.length > maxMobileAds*maxMobileChildCount){
    maxMobileChildCount = Math.floor(tags.length/maxMobileAds);
    console.log("spreading Ads");
    console.log(maxMobileChildCount);
  }
  if(tags.length > maxDesktopAds*maxChildCount){
    maxChildCount = Math.floor(tags.length/maxDesktopAds);
    console.log("spreading Ads");
    console.log(maxChildCount);
  }

console.log("has above tags");
console.log($(".single-body").children());
console.log(tags);


$.each(tags,function(x,i){
  adCount++;
if(is_mobile === true){
  if(adCount % maxMobileChildCount == 0){
    console.log("mobile injection");
$(i).after('<div class="ad ad-inline mobile"><div id="dfp_block_'+adSizes[currentAdCount]+'" class="dfp_block" data-label="'+adSizes[currentAdCount]+'" data-size="728x90" data-mobilesize="300x250"></div></div>');
//googletag.display(mobileAdSizes[currentAdCount]);
    console.log("adding");
    //slots[mobileAdSizes[currentAdCount]] = googletag.defineSlot('/4848013/'+mobileAdSizes[currentAdCount], [[300, 250]], mobileAdSizes[currentAdCount]).addService(googletag.pubads());
    //var mapping = googletag.sizeMapping().
   //addSize([0, 0], []).
//addSize([320, 700], [300, 250]). // Tablet
//addSize([1050, 200], []). // Desktop
//build();
    //slots[mobileAdSizes[currentAdCount]].defineSizeMapping(mapping);
    //console.log(slots[mobileAdSizes[currentAdCount]]);
    currentAdCount++;
}
}else{
  if(adCount % maxChildCount == 0){
    console.log("desktop injection");
$(i).after('<div class="ad ad-inline desktop"><div id="dfp_block_'+adSizes[currentAdCount]+'" class="dfp_block" data-label="'+adSizes[currentAdCount]+'" data-size="728x90" data-mobilesize="300x250"></div></div>');
//googletag.display(desktopAdSizes[currentAdCount]);
    console.log("adding");
 //    var mapping;
 //    slots[desktopAdSizes[currentAdCount]] = googletag.defineSlot('/4848013/'+desktopAdSizes[currentAdCount], [[400, 225]], desktopAdSizes[currentAdCount]).addService(googletag.pubads());
 //    var mapping = googletag.sizeMapping().
 //   addSize([0, 0], []).
 //   addSize([1024, 768], [400, 225]).
 // build();
 //    slots[desktopAdSizes[currentAdCount]].setTargeting('Newspapers', adNewspaper);
 //    slots[desktopAdSizes[currentAdCount]].setTargeting('categories', adCats);
 //    slots[desktopAdSizes[currentAdCount]].setTargeting('slug', adSlug);
 //    slots[desktopAdSizes[currentAdCount]].setTargeting('pagetype', adPagetype);
 //    slots[desktopAdSizes[currentAdCount]].defineSizeMapping(mapping);
 //    console.log(slots[desktopAdSizes[currentAdCount]]);
    currentAdCount++;
}
}

});

}
}

$(window).scroll(function(){
});
var autoscroll = false;
function check_for_ads_in_view(){
	//console.log("checking for ads");


  if($('.dfp_block').length > 0){
		$('.dfp_block').each(function(){
// 			if($(window).scrollTop() + $(window).height() + 100 > $(this).offset().top && !$(this).hasClass('rendered') && $(window).scrollTop() - 300 < $(this).offset().top && !autoscroll){
					//console.log("getting The Ad");

        var adData = $(this).data();
        var adId = adData.label;
        get_dfp_by_tag(adId);
				$(this).addClass('rendered');
			//}
		});
	}
}

function get_dfp_by_tag(tag){
	if($('#'+tag).length<1){
	$('#dfp_block_'+tag).append("<div id='"+tag+"'></div>");
	googletag.cmd.push(function() { googletag.display(tag); });
	console.log('getting Ads ' + tag);
	console.log(googletag);
	}
/*
  $.ajax({
    url: ajaxurl,
    data: {
      action: 'do_ajax',
      fn: 'get_dfp_ad',
      adid: tag
    },
    success: function(data){
      if(data){
        $('#dfp_block_'+tag).append(data);
        console.log(data);
      }
    },
  });
*/

  }







function snapClicks(snaps, postID){
  console.log('adding ' + snaps +' clicks to post ' + postID );
  $.ajax({
	    url: ajaxurl,
	    data: {
	        action: 'do_ajax',
	        fn: 'updateSnaps',
          postID: postID,
          snaps: snaps,
	    },
	    success: function(data){
        if(data !== null){
          console.log(data);
        }
	    },
	    complete:function(){
		},
		error: function(errorThrown) {
			console.log(errorThrown);
		}
	});



}

function mobile_init(){
    console.log('mobile');
    if($('body').hasClass('home')){
      $(".popular-posts-slick-mobile").slick({
        dots: false,
        arrows: false,
        swipeToSlide: true,
        infinite: false,
      });

      $('.popular-posts-selector .selected-indicator').css('left', $('.popular-posts-selector h3.active').position().left );
      $('.popular-posts-selector .selected-indicator').css('width', $('.popular-posts-selector h3.active').width()/2 );

      $('.popular-posts-selector h3').each(function (i, val) {
        var slideNum = $(val).attr('slideindex');
        $(this).click(function () {
          console.log('clicke');
          $(".popular-posts-slick-mobile").slick('slickGoTo', slideNum);
          $(".popular-posts-selector h3").removeClass('active');
          $(this).addClass("active");
          var leftPos = $(this).position().left;
          var length = $(this).width()/2;
          $('.popular-posts-selector .selected-indicator').css('left', leftPos );
          $('.popular-posts-selector .selected-indicator').css('width', length );
        });
      });

      $('.popular-posts-slick-mobile').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $(".popular-posts-selector h3").removeClass('active');
        $('.popular-posts-selector h3[slideindex='+ nextSlide +']').addClass('active');
        var selector = $(".popular-posts-selector h3.active");
        $('.popular-posts-selector .selected-indicator').css('left', selector.position().left );
        $('.popular-posts-selector .selected-indicator').css('width', selector.width()/2 );
      });

    }
}

// newsletter AJAX validation
function register($form) {
    $.ajax({
        type: $form.attr('method'),
        url: $form.attr('action'),
        data: $form.serialize(),
        cache       : false,
        dataType    : 'json',
        contentType: "application/json; charset=utf-8",
        error       : function(err) { alert("Could not connect to the registration server. Please try again later."); },
        success     : function(data) {
            if (data.result != "success") {
                // Something went wrong, do something to notify the user. maybe alert(data.msg);

                //display an error message
                if (data.msg[0] == "0") {
                    $('.errorMsg').html("Please enter a valid email.");
                    $('.errorMsg').addClass('active');
                } else {
                    $('.errorMsg').html(data.msg);
                    $('.errorMsg').addClass('active');
                }

            } else {
                $form.addClass('success');
                if ($form.hasClass('footer-subscribe')) {
                    $('.errorMsg').html("Thank you!");
                    $('.errorMsg').addClass('active');
                };
            }
        }
    });
}

function validate_input($form) {
    return true;
}




function loadByYear(year){
  console.log('loading  ' + year);
  $(".product").css('opacity',0);
  $.ajax({
	    url: ajaxurl,
	    data: {
	        action: 'do_ajax',
	        fn: 'get_issues_by_year',
          year: year,
	    },
	    success: function(data){
        if(data !== null){
          console.log(data);
          $(".issueArchive").html(data);
          $(".product").css('opacity',0);
          $(".product").css('transition','1s all');
          $(".product").each(function(i,x){
	          var t = $(this);
	          setTimeout(function(){
		          $(t).css('opacity',1);
	          },i*300)
	          });


        }
	    },
	    complete:function(){
		},
		error: function(errorThrown) {
			console.log(errorThrown);
		}
	});



}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}



// WEBPACK FOOTER //
// ./js/script.js